import React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import QrGen from "./pages/QRgen";
import TabsLayout from "./components/layout/TabsLayout";
import StickerGen from "./pages/Sticker";
import Base64 from "./pages/Base64";
import Time from "./pages/Time";
import Calculator from "./pages/Calculator";
import Mix from "./pages/Mix";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TabsLayout item="qr"><QrGen/></TabsLayout>}/>
          <Route path="/qr" element={<TabsLayout item="qr"><QrGen/></TabsLayout>}/>
          <Route path="/sticker" element={<TabsLayout item="sticker"><StickerGen/></TabsLayout>}/>
          <Route path="/base64" element={<TabsLayout item="base64"><Base64/></TabsLayout>}/>
          <Route path="/time" element={<TabsLayout item="time"><Time/></TabsLayout>}/>
          <Route path="/calculator" element={<TabsLayout item="calculator"><Calculator/></TabsLayout>}/>
          <Route path="/mix" element={<TabsLayout item="mix"><Mix/></TabsLayout>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
